module.exports = __webpack_public_path__ + "img/ALL.83af3c21.png";